export class PopupPage extends PIXI.Container {
    constructor() {
        super();
    }

    public cleanUp() {
        this.removeAllListeners();
    }
}
